<div class="risk__wrapper">
	<div class="mb-2"><activar-icon [name]="getIcon()" size="40px"/></div>
	@if (risk()) {
		<div>{{ risk()?.name }}</div>
	}
</div>
